import React, { useEffect, useState } from 'react'
import { Parallax } from 'react-scroll-parallax'
import DarkModeToggle from "react-dark-mode-toggle"

import './main.css'
import './nav.css'
import './about.css'

import Resume from './Resume'
import Project from './Project'
import Feedback from './Feedback'
import Footer from './Footer'
import Skill from './Skill'
import More from './More'

import LinkedInIcon from '@material-ui/icons/LinkedIn'
import GitHubIcon from '@material-ui/icons/GitHub'
import PersonPinIcon from '@material-ui/icons/PersonPin'
import HomeIcon from '@material-ui/icons/Home'
import SchoolIcon from '@material-ui/icons/School'
import PermContactCalendarIcon from '@material-ui/icons/PermContactCalendar'
import AdbIcon from '@material-ui/icons/Adb'
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp'
import InstagramIcon from '@material-ui/icons/Instagram'
import star from "./images/stars.png"
import null_pic from "./images/null.png"
import moon from "./images/moon.png"
import sun from "./images/sun.png"
import mountain from "./images/mountains_behind.png"
import mountainDay from "./images/mountains_behind_day.png"
import bg from "./images/bg2.png"
import bgDay from "./images/bg2_day.png"
import Typist from 'react-typist';
import Scrollspy from 'react-scrollspy'
import Goku from './Goku';
import Logo from './img/logo.png'
import Banner from './Banner';
import Time from './Time';

function Main({bool}) {

    const [isDarkMode,setIsDarkMode] = useState(false)
    const [offset,setOffset] = useState()

    useEffect(() => {
        console.log('')
    }, [])

    const handleScroll = () => setOffset(window.pageYOffset)
    window.addEventListener('scroll',handleScroll)

    const topFunction = (e) => {
        e.preventDefault();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    const desc = "<Developer/>";

    return (
        <div className = 'main_body' id = 'home'>
            <button id = 'btn' className = "myBtn" onClick = {topFunction} style = {{display : `${bool ? 'block':'none'}`}}><KeyboardArrowUpIcon fontSize = 'large'/></button>
            <div className = 'nav'>
                <Scrollspy className = 'nav_btn' items = {[]} currentClassName = 'isActive'>
                    <a href = {'#home'} rel="noopener noreferrer"><HomeIcon fontSize = 'large'/></a>
                    <a href = '#about'><PersonPinIcon fontSize = 'large'/></a>
                    <a href = '#resume'><SchoolIcon fontSize = 'large'/></a>
                    <a href = '#project'><AdbIcon fontSize = 'large'/></a>
                    <a href = '#feedback'><PermContactCalendarIcon fontSize = 'large'/></a>
                    <DarkModeToggle className = 'darkModeBtn' onChange={setIsDarkMode} checked={isDarkMode} size={80}/>
                </Scrollspy>
            </div>
            <div className= {isDarkMode?'main_parallax':'main_parallax_day'} id = 'home'>
                <header className = "main_header">
                    <a href = "/" rel="noopener noreferrer" className = "main_logo"><img src = {Logo} alt = 'logo'/></a>
                    <div className = 'main_header_text'>
                        <p>Sanket Dev</p>
                    </div>
                </header>
                <div className = "main_section">
                    <img src = {star} style = {{left:(offset * 1)+ 'px'}} className = {isDarkMode?"Darkstar_active":"Darkstar"} alt = ''/>
                    <img src = {null_pic} style = {{left:(offset * 1)+ 'px'}} className = "star" alt = ''/>
                    <img src = {moon} style = {{top:(offset * 1.05)+ 'px'}}  className = {isDarkMode?"moon":"moon_deactive"} alt = 'moon'/>
                    <img src = {sun} style = {{top:(offset * 1.05)+ 'px'}}  className = {isDarkMode?"sun_deactive":"moon"} alt = 'moon'/>
                    <img src = {mountain} style = {{top:(offset * 0.5)+ 'px'}} className = {isDarkMode?"mountain":"mountain_deactive"} alt = 'mountain'/>
                    <img src = {mountainDay} style = {{top:(offset * 0.5)+ 'px'}} className =  {isDarkMode?"mountain_deactive":"mountain"} alt = 'mountain'/>
                    <p className = "text" style = {{marginRight:(offset * 0.8)+ 'px',marginTop : (offset * 1.5)+ 'px'}}>~Sanket Puhan<br></br>{desc}</p>
                    <img className = {isDarkMode?"main_section_bg":"main_section_bg_deactive"} src =  {bg} style = {{top:(offset * 0)+ 'px'}}  alt = 'mountain'/>
                    <img className = {isDarkMode?"main_section_bg_deactive":"main_section_bg"} src =  {bgDay} style = {{top:(offset * 0)+ 'px'}}  alt = 'mountain'/>
                    <div className = 'main_section_social' style = {{marginRight:(offset * 0.0)+ 'px',marginTop : (offset * 1.4) + 'px'}}>
                        <a href = 'https://github.com/geek-ninja' target = '_blank' rel="noopener noreferrer" style = {{marginRight:(offset * 0.0)+ 'px',marginTop : (offset * 1.8) + 'px'}} ><GitHubIcon fontSize = 'large'/></a>
                        <a href = 'https://www.linkedin.com/in/sanket-puhan-9261a8198/' target = '_blank' rel="noopener noreferrer" style = {{marginRight:(offset * 0.0)+ 'px',marginTop : (offset * 1.8) + 'px'}}><LinkedInIcon fontSize = 'large'/></a>
                        <a href = 'https://www.instagram.com/sanket_kyrie11/' target = '_blank' rel="noopener noreferrer" style = {{marginRight:(offset * 0.0)+ 'px',marginTop : (offset * 1.8) + 'px'}} ><InstagramIcon fontSize = 'large'/></a>
                    </div>

                </div>
                <div className = "main_text" id = 'about'>
                    <div className = 'about_mobile'>
                        <Parallax y = {[150,-150]}><h2 className = 'main_text_h2'>About Me</h2></Parallax>
                        <Parallax x = {[100,-100]}>
                        <p className = 'main_text_p'>
                        My name is Sanket, and I've been working in Web development and Machine Learning for over 2 years, making my way up the professional ladder and learning the ins and outs of programming. I worked on my own projects and websites, largely in Python and HTML, CSS, and Javascript. Working on machine learning and open source projects linked to it right now. Development is enjoyable, and I am eager to use what I've learnt from my previous failures.
                            <br></br>
                            ~ Happy Coding
                            </p>
                        </Parallax>
                    </div>
                    <div className = 'about_pc'>
                        <div class="mockup_wrap">
                            <div class="md-macbook-pro md-glare">
                            <div class="md-lid">
                                <div class="md-camera"></div>
                                <div class="md-screen">
                            
                                    <div className = 'about_screen_text'>
                                    <div className="canvas">
                                        <div className="shot">
                                        <div className="window-buttons">
                                            <span className="close">•</span><span className="minimize">•</span><span className="maximize">•</span>
                                        </div>
                                        <p><span>{'>'} </span>hello world ...</p>
                                        <p><span>{'>'} </span> <span className="blink">_</span> </p>
                                        <p><span>{'>'} </span><Typist startDelay = {5000}><p className = 'typing'>~ My name is Sanket Puhan, and I've been working in Web development and Machine Learning for over 2 years, making my way up the professional ladder and learning the ins and outs of programming. I worked on my own projects and websites, largely in Python and HTML, CSS, and Javascript. Working on machine learning and open source projects linked to it right now. Development is enjoyable, and I am eager to use what I've learnt from my previous failures. <span className = 'blink'>|</span></p></Typist> </p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            <div class="md-base"></div>
                            </div>

                            <div class="md-ipad md-white-device md-glare right-mockup">
                            <div class="md-body">
                                <div class="md-front-camera"></div>
                                <div class="md-screen">
                                    <div className = 'about_ipad'>
                                        <img src = 'https://cdn.dribbble.com/users/720825/screenshots/3253310/slim-jim-_dribbble_-_800x600_.gif' alt = 'about_ipad'/>
                                        <h1>I'm Software and Web Designer <br></br><span><p>Turning Your Paperball Into Paperplane !</p></span></h1>
                                    </div>
                                </div>
                            </div>
                            </div>

                            <div class="md-iphone-5 md-white-device md-glare left-mockup">
                            <div class="md-body">
                                <div class="md-buttons"></div>
                                <div class="md-front-camera"></div>
                                <div class="md-top-speaker"></div>
                                <div class="md-screen">
                                    <div className = 'about_mobile'>
                                        <img src = 'https://cdni.iconscout.com/illustration/premium/thumb/man-using-mobile-phone-2839467-2371260.png' alt = 'about_mobile'/>
                                        <div className = 'about_mobile_screen'>
                                            <div className = 'about_mobile_logo'>
                                                <h1>Get in touch !</h1>
                                            </div>
                                            <p>Jagannath Nagar, Rasulgarh</p>
                                            <p>Bhubaneswar</p>
                                            <p>Odisha (PIN: 751025)</p>
                                            <p>(+91)9438340718</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className = 'main_others'>
            <div id = 'resume'><Resume/></div>
            <div id = 'banner'><Banner/></div>
            <div id = 'time'><Time/></div>
            <div id = 'skill'><Skill/></div>
            <div id = 'goku'><Goku/></div>
            <div id = 'project'><Project/></div>
            <div id = 'more'><More/></div>
            <div id = 'feedback'><Feedback/></div>
            <div id = 'footer'><Footer/></div>
            </div>
        </div>
    )
}

export default Main
